<app-page-ribbon></app-page-ribbon>
<app-loader
        [isLoading]="isLoading$ | async"
        [message]="loadingMessage$ | async">
</app-loader>

<router-outlet></router-outlet>

